import React from 'react';

const Icon = ({ path, style = {} }) => {
    return <img src={`/assets/images/${path}.svg`} alt="icon" style={style} />;
};

export default Icon;
